export * from './icon.component'
